var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 204,
    height: 192,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m49.39 83.06 4.75-.025s11.38-14.251 19.07-15.04l.712-40.153C44.47 27.94 18.478 44.367 6.64 68.648L49.39 83.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M106.207 100.856c-2.415 13.193-14.555 23.566-29.427 24.023-3.662.113-7.93-2.059-7.93-2.059s-3.917.213-4.587-.046L41.048 158.36c10.79 4.822 22.98 7.185 35.732 6.46 37.082-2.109 66.236-29.745 69.474-63.014l-40.047-.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "m33.78 154.617 4.645.158 18.784-35.848c-7.008-5.137-11.511-13.131-11.511-22.197 0-2.19.265-4.327.765-6.383L8.203 76.053l-4.652.053A64.814 64.814 0 0 0 0 97.284c0 24.414 13.53 45.434 33.78 57.333Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M81.327 68.17c13.544 1.996 23.958 12.386 25.195 25.227l65.485 1.88v-.083c0-.05 9.873-1.572 9.873-1.578C181.877 93.17 92.421.078 92.421.078l-9.922 1.614-1.173 66.477.001.001Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M54.076 83.06c4.743-8.214 13.567-14.015 23.82-15.065l.712-40.154c-29.452.098-55.444 16.525-67.282 40.806l42.75 14.413Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M110.892 100.856c-2.414 13.193-14.554 23.566-29.427 24.023-4.434.137-8.672-.621-12.517-2.105L45.733 158.36c10.79 4.822 22.98 7.185 35.732 6.46 37.082-2.109 66.236-29.745 69.473-63.014l-40.046-.95Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m38.467 154.617 23.428-35.69c-7.008-5.137-11.512-13.131-11.512-22.197 0-2.19.266-4.327.765-6.383L8.236 76.107a64.862 64.862 0 0 0-3.55 21.179c0 24.414 13.53 45.433 33.78 57.332v-.001Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M91.2 66.477c13.544 1.995 23.958 12.386 25.195 25.227l65.485 1.879V93.5c.001-47.559-38.276-88.26-89.507-93.5l-1.174 66.477h.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M72.512 123.908c-1.22-.31-2.41-.689-3.563-1.134l-23.216 35.585c10.791 4.823 22.981 7.186 35.733 6.46 10.302-.586 19.991-3.144 28.684-7.244-8.775-1.316-16.61-4.61-22.865-10.101-7.126-6.255-11.748-14.955-14.773-23.565v-.001Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M64.718 43.779c-2.757-5.034-6.699-8.849-11.122-11.763-18.612 6.358-33.943 19.552-42.27 36.631l42.75 14.414c2.967-5.14 7.533-9.335 13.047-12.012 1.114-10.684 2.378-18.537-2.405-27.27Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M93.847 93.812c0 9.923-7.774 17.728-17.71 17.424-10.34-.317-19.037-9.23-19.037-19.896s8.696-18.41 19.037-17.335c9.936 1.033 17.71 9.884 17.71 19.807Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M96.532 92.957c0 9.922-7.775 17.728-17.71 17.424-10.34-.318-19.038-9.231-19.038-19.897 0-10.666 8.697-18.41 19.038-17.335 9.935 1.033 17.71 9.885 17.71 19.808Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M95.752 92.904c0 9.486-7.439 16.936-16.93 16.629-9.86-.319-18.14-8.825-18.14-18.988s8.28-17.556 18.14-16.548c9.491.971 16.93 9.421 16.93 18.907Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M95.193 92.867c0 9.172-7.197 16.367-16.371 16.06-9.518-.319-17.5-8.535-17.5-18.34 0-9.804 7.982-16.946 17.5-15.984 9.174.927 16.371 9.09 16.371 18.264Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEEF06",
    d: "m85.121 96.596 2.494 2.4c-1.923 2.278-4.868 3.508-8.323 3.508-5.317 0-9.524-3.089-10.816-7.677h-3.425v-2.099h3.034c-.03-.33-.03-.66-.03-1.02s0-.689.03-1.02h-3.034V88.59h3.425c1.292-4.588 5.499-7.677 10.816-7.677 3.455 0 6.4 1.23 8.323 3.509l-2.494 2.37c-1.532-1.65-3.425-2.46-5.618-2.46-3.215 0-5.769 1.65-6.91 4.259h8.622v2.098h-9.194c-.03.33-.06.66-.06 1.02s.03.69.06 1.02h9.194v2.099h-8.623c1.142 2.608 3.696 4.258 6.91 4.258 2.194 0 4.087-.81 5.619-2.489Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M75.859 95.112c.553-5.452 5.574-7.76 4.919-12.776-.404-3.091-2.752-5.696-5.37-7.73-7.944.83-14.086 7.395-14.086 15.981 0 9.805 7.982 18.021 17.499 18.34.924.031 1.826-.018 2.704-.132-3.78-3.755-6.142-8.999-5.667-13.683h.001Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M143.823 186.679s-7.589 3.464-7.711 4.015c-.123.55 4.885-.196 6.931-.122 2.045.074 3.726-.533 3.539-1.397-.187-.864-.908-3.037-.908-3.037l-1.85.541h-.001Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "m143.538 183.882.471 3.413s1.203.425 2.01-.082l.336-3.746-2.817.415Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "m179.317 183.879.887 1.413c.248.396.323.872.205 1.323-.306 1.178-.917 3.475-1.185 4.073-.365.816-5.28 1.312-5.28 1.312s-.44-.615.579-1.361 1.675-.865 2.032-1.963c.358-1.099.591-4.204.591-4.204l2.171-.594v.001Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M175.63 180.289c.324.256 1.914 5.035 1.914 5.035s.513.651 1.482-.313c.969-.965.438-.433.438-.433l-.193-4.705-3.641.416Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M139.193 115.301a371.772 371.772 0 0 0 4.001 69.825 32.028 32.028 0 0 0 3.3-.069 84.641 84.641 0 0 0 2.794-8.992c.957-3.822 1.532-7.249 1.94-10.527 1.435-11.538-.282-12.54.885-21.091 1.034-7.574 2.528-7.873 4.257-18.626 1.877-11.668.455-13.414-.236-14.045-2.942-2.684-9.832-.835-16.941 3.525Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M156.134 111.776c-2.806-2.56-9.205-.991-15.958 2.943 7.8 8.37 8.661 13.811 7.737 17.344-1.045 3.993-4.246 5.151-4.224 9.515.029 5.362 4.881 6.772 4.791 12.447-.059 3.752-2.19 3.718-2.682 8.354-.582 5.485 2.207 7.369 1.314 11.428-.384 1.747-1.485 4.03-4.633 6.387a378.3 378.3 0 0 0 .716 4.932 32.816 32.816 0 0 0 3.3-.069 84.361 84.361 0 0 0 2.793-8.992c.958-3.822 1.533-7.249 1.941-10.526 1.435-11.539-.282-12.541.885-21.092 1.033-7.574 2.528-7.873 4.257-18.627 1.877-11.668.454-13.413-.236-14.044h-.001Z",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M144.011 115.119a228.893 228.893 0 0 1 20.474 36.482 228.49 228.49 0 0 1 11.098 30.542 4.1 4.1 0 0 0 2.243.342c1.446-.195 2.311-1.119 2.537-1.376a65.76 65.76 0 0 0 .544-16.241c-.237-2.584-.654-6.888-2.318-12.199-1.863-5.949-3.135-6.281-5.564-12.574-2.519-6.532-1.917-8.165-4.335-16.34-.993-3.359-2.654-8.356-5.39-14.333l-19.289 5.698v-.001Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M116.705 101.339c.063 2.377 3.977 4.469 7.128 5.111 7.368 1.501 15.909-3.842 19.964-9.753.796-1.16 1.681-2.567 1.894-2.458.482.246-3.947 7.509-5.867 15.77-.983 4.226-.726 6.206-2.562 9.019-.416.637-.929 1.301-.749 2.055.451 1.888 4.778 2.378 7.78 2.718 3.168.36 6.123.324 9.045.282 4.676-.068 5.044-.311 6.112.212 3.252 1.593 3.032 5.411 5.479 5.92 2.056.428 4.141-1.863 4.802-2.59 3.437-3.775 3.253-8.327 3.863-12.919 1.417-10.675 7.227-22.37 12.912-29.774 1.723-2.246 2.922-3.427 2.998-5.514.219-6.125-9.504-12.888-17.599-13.665-2.219-.212-6.193-.145-9.918.206-1.488.14-3.073.346-4.777.643-4.131.721-7.007 1.223-9.939 2.562-11.82 5.397-9.24 17.413-22.033 25.72-4.399 2.856-8.599 3.965-8.532 6.453l-.001.002Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M165.133 59.4s.508 2.827 1.677 4.84c1.056 1.82 5.422 2.47 6.331 2.787.91.317-1.372 1.898-3.799 2.471-2.427.574-9.526.949-10.916.186-1.391-.762.903-.995 2.573-1.871 1.67-.877 2.228-4.439 1.711-5.953-.517-1.514 2.423-2.46 2.423-2.46Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M157.841 52.932c-4.11-2.932-5.248-10.86-2.965-12.64.652-.508 1.275-.274 10.55 3.44 4.606 1.844 6.872 2.826 7.618 4.856.456 1.239.382 2.913-.121 4.232-.259.679-.764 1.524-1.887 3.137-.996 1.431-.93 1.382-1.235 1.799-.734.999-2.149 2.681-4.743 4.631a15.677 15.677 0 0 0-.754-2.622c-.147-.38-.739-1.865-1.679-3.116-1.617-2.153-3.451-2.766-4.785-3.717h.001Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M168.374 60.471s-2.689 3.998-7.67 3.456c-4.459-.486-4.675-10.524-1.725-12.524.984-.667 2.905-.878 4.438-.376.906.297 1.199.69 2.688 1.146 1.373.42 1.773.284 2.176.654.505.464.842 1.56-.162 4.45.891-.826 1.93-1.112 2.64-.738.114.06.412.281.571.605.575 1.17-.535 2.585-2.955 3.328h-.001Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M127.039 100.973c5.342-1.2 7.47-1.162 10.112-3.286 4.398-3.537 5.059-8.92 7.615-8.854 1.208.03 2.189 1.262 2.887 2.467l-1.93 3.018c-.003-.039-.011-.068-.033-.08-.213-.108-1.097 1.3-1.894 2.46-4.054 5.91-12.595 11.253-19.963 9.752-2.113-.43-4.563-1.514-5.971-2.898a91.175 91.175 0 0 1 9.177-2.579Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M183.256 121.471c3.237.288 10.521.42 15.674-4.338 8.577-7.92 4.322-22.995 1.336-29.478-3.423-7.433-8.871-11.595-12.182-14.123-4.108-3.137-6.615-5.051-9.632-4.623-7.801 1.109-13.204 17.067-8.921 21.636 1.402 1.496 2.79.65 6.847 1.939 1.321.42 11.184 3.555 12.901 10.804 1.201 5.075-1.858 11.016-7.304 15.006l1.281 3.177Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M146.983 118.842c3.664-2.311 4.205-4.653 8.308-6.236 5.33-2.056 7.891.556 10.534-1.553 3.144-2.51.36-6.881 2.714-14.468.399-1.287 3.434-11.068 10.394-12.314 3.246-.58 7.533.66 9.186 3.406 1.293 2.148.088 3.75 1.66 6.122 1.571 2.37 3.449 1.79 5.452 3.767 3.18 3.14 3.668 9.759.797 13.504-1.339 1.746-3.079 2.436-6.353 3.735-2 .794-3.859 1.288-5.46 1.601 4.009-3.84 6.09-8.793 5.065-13.119-1.07-4.52-5.305-7.439-8.664-9.1-3.361 6.314-6.108 13.628-7.022 20.519-.609 4.592-.426 9.144-3.862 12.92-.661.727-2.746 3.017-4.802 2.59-2.448-.509-2.228-4.327-5.48-5.92-1.067-.523-1.435-.281-6.112-.212-2.921.042-5.876.077-9.045-.282-2.669-.303-6.38-.727-7.487-2.144 4.818-.131 8.035-1.464 10.178-2.816h-.001Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "m181.132 124.009.377-1.107c.601-1.765-.387-3.647-2.206-4.2l-71.316-21.683-2.173 7.352 70.956 21.813c1.81.556 3.763-.416 4.362-2.175Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M37.12 77.103c5.453-21.5 26.82-34.457 47.95-28.385 21.52 6.185 33.84 29.455 27.302 51.391-6.385 21.422-28.28 32.978-48.71 26.369-20.078-6.496-31.87-28.364-26.542-49.375Zm69.044 21.11c5.404-18.359-4.906-37.803-22.876-43.02-17.698-5.14-35.679 5.647-40.319 23.698-4.55 17.706 5.387 36.162 22.34 41.599 17.205 5.517 35.558-4.281 40.855-22.278Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D8DEE8",
    d: "m107.987 97.02 9.093 2.764c.624 2.895 1.837 4.553 3.058 5.563 4.593 3.8 10.725-.344 19.282 4.112 4.294 2.236 3.478 3.659 7.503 5.219 6.654 2.579 9.699-.993 15.588 1.355 5.956 2.374 6.543 7.506 9.921 7.322 1.445-.078 3.305-1.128 5.38-5.106l1.491.454c1.819.553 2.807 2.435 2.206 4.2l-.377 1.106c-.599 1.759-2.553 2.732-4.362 2.176l-70.956-21.813 2.173-7.352Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.626 123.432c17.795 5.716 36.795-4.406 42.29-23.029 5.608-19.012-5.069-39.152-23.684-44.547-18.325-5.311-36.926 5.87-41.716 24.552-4.696 18.312 5.582 37.395 23.11 43.024Z",
    opacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M35.738 78.947c5.453-21.5 26.82-34.457 47.951-28.384 21.519 6.184 33.839 29.454 27.301 51.39-6.384 21.422-28.28 32.978-48.71 26.369-20.078-6.495-31.87-28.364-26.542-49.375Zm69.045 21.109c5.403-18.358-4.906-37.802-22.876-43.02-17.698-5.139-35.679 5.648-40.319 23.7-4.55 17.705 5.387 36.161 22.34 41.598 17.205 5.517 35.558-4.281 40.855-22.278Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M37.804 79.578c5.167-20.28 25.339-32.466 45.254-26.721 20.258 5.843 31.866 27.756 25.733 48.424-5.997 20.211-26.637 31.149-45.929 24.927-18.976-6.12-30.114-26.785-25.057-46.63h-.001Zm66.979 20.478c5.403-18.358-4.906-37.803-22.876-43.02-17.698-5.14-35.679 5.647-40.319 23.699-4.55 17.706 5.387 36.161 22.34 41.598 17.205 5.518 35.558-4.281 40.855-22.277Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "m182.982 120.789-.721-1.788s-1.176.072-2.142-.619c-.526-.377-1.459-.489-1.731-.414-.272.075-1.296.031-.128.587 1.168.556 1.159.97.672 1.426-.487.456-2.339 1.438-3.006 1.486-.667.047.539 1.077 1.211 1.208.673.131 1.776.297 3.14-.504.498-.293 2.706-1.382 2.706-1.382h-.001Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M118.339 105.558s-3.014-.299-4.81-1.066c-1.796-.767-2.957.334-2.792 1.097.165.762 3.12 1.823 4.301 1.862 1.18.038 3.301-1.892 3.301-1.892v-.001Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 91.041,
    x2: 147.428,
    y1: 124.824,
    y2: 238.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 175.78,
    x2: 177.719,
    y1: 171.837,
    y2: 195.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.356,
    x2: 84.243,
    y1: 76.841,
    y2: 183.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 197.135,
    x2: 109.077,
    y1: 69.551,
    y2: 79.923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#893976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 42.022,
    x2: 56.327,
    y1: 21.671,
    y2: 151.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 95.727,
    x2: 152.113,
    y1: 124.824,
    y2: 238.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B306E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 6.059,
    x2: 85.995,
    y1: 76.862,
    y2: 179.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 177.493,
    x2: 116.957,
    y1: -9.392,
    y2: 75.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A03976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#983672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#843169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#63275A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#351A46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311944"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 68.55,
    x2: 123.899,
    y1: 139.037,
    y2: 251.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 35.334,
    x2: 49.614,
    y1: 22.522,
    y2: 151.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 69.175,
    x2: 47.753,
    y1: 94.588,
    y2: 101.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 86.512,
    x2: 67.441,
    y1: 73.297,
    y2: 115.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEF06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 82.992,
    x2: 79.314,
    y1: 117.78,
    y2: 97.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 75.165,
    x2: 90.331,
    y1: 85.2,
    y2: 117.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 70.69,
    x2: 85.825,
    y1: 87.286,
    y2: 119.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB148"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FEC144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FDB946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F99C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8924F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8924F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 140.12,
    x2: 142.059,
    y1: 174.72,
    y2: 198.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 145.025,
    x2: 144.623,
    y1: 188.056,
    y2: 163.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 37.326,
    x2: 51.766,
    y1: 21.581,
    y2: 152.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 177.711,
    x2: 177.309,
    y1: 187.526,
    y2: 162.696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 165.97,
    x2: 139.659,
    y1: 77.914,
    y2: 160.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 138.989,
    x2: 157.383,
    y1: 147.846,
    y2: 147.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 197.32,
    x2: 164.661,
    y1: 123.509,
    y2: 146.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A03976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 174.897,
    x2: 133.291,
    y1: 62.453,
    y2: 130.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 163.495,
    x2: 165.908,
    y1: 47.178,
    y2: 70.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 174.12,
    x2: 161.228,
    y1: 78.744,
    y2: 40.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#441900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#632700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 171.478,
    x2: 157.015,
    y1: 57.364,
    y2: 57.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#F58568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F8A987"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FBC6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FDDBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FEE7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 117.863,
    x2: 147.653,
    y1: 97.769,
    y2: 97.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 197.471,
    x2: 155.865,
    y1: 76.176,
    y2: 144.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 136.804,
    x2: 197.924,
    y1: 107.2,
    y2: 107.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 105.814,
    x2: 181.685,
    y1: 111.68,
    y2: 111.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 35.84,
    x2: 114.125,
    y1: 87.777,
    y2: 87.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 64.412,
    x2: 76.961,
    y1: 131.738,
    y2: 74.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 83.143,
    x2: 65.63,
    y1: 47.289,
    y2: 124.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 182.981,
    x2: 175.73,
    y1: 120.366,
    y2: 120.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 118.339,
    x2: 110.722,
    y1: 105.841,
    y2: 105.841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F36F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.28ad3ccfd7f8c09bf28adc4f36af91e9.svg";
export { ForwardRef as ReactComponent };